import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "staff-page" }
const _hoisted_2 = { class: "table-toolbar" }
const _hoisted_3 = {
  class: "segmented-control",
  role: "group",
  "aria-label": "Подключения"
}
const _hoisted_4 = { class: "ui-field table-search" }
const _hoisted_5 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_6 = { class: "ui-table-scroll" }
const _hoisted_7 = { class: "ui-table connection-table" }
const _hoisted_8 = { class: "inline-flex items-center gap-2" }
const _hoisted_9 = { class: "staff-avatar staff-avatar--small" }
const _hoisted_10 = { class: "num whitespace-nowrap" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "table-pagination" }
const _hoisted_13 = { class: "flex items-center gap-2 text-xs text-muted-foreground" }
const _hoisted_14 = ["value"]

import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { computed } from 'vue';
import { ArrowDownUp, ChevronLeft, ChevronRight } from '@lucide/vue';

import { ref, watch, onMounted } from 'vue';
import axios from 'axios';
import { useMainStore } from '@/store';
import { dateTimeToDateWithTimeString } from '@/filters/date_filters';

interface FilteredConnection {
  slotId: number;
  property: string;
  propertyId: number;
  slotInfo: string;
  product: string;
  userInfo: string;
  date_started: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActiveConnectionList',
  setup(__props) {

const store = useMainStore();

const loading = ref(true);
const releaseLoad = ref(false);
const search = ref('');
const tab = ref(0);

const filteredConnections = ref<FilteredConnection[]>([]);
const allConnections = ref<Connection[]>([]);

function formatDateTime(dateTime: string): string {
  return dateTimeToDateWithTimeString(dateTime) || '';
}

watch(tab, async () => {
  compileTableConnections();
});

function isCanBeReleased(item: any): boolean {
  const connection = allConnections.value.find((x) => x.slot.id === item.slotId) as Connection;

  if (connection && connection.user.username == store.currentUserName) {
    return true;
  }

  return false;
}

async function release(id: number) {
  releaseLoad.value = true;

  await axios.post('/api/slots/' + id + '/release/').then(
    (response) => {
      if (response.status == 201) {
        loadConnections();
      }
    },
    () => undefined
  );
  releaseLoad.value = false;
}

function compileTableConnections() {
  filteredConnections.value = [];
  allConnections.value.forEach((element) => {
    if (filterConnection(element)) {
      const item: FilteredConnection = {
        slotId: element.slot.id,
        property: element.slot.property.name,
        propertyId: element.slot.property.id,
        slotInfo: `${element.slot.type}: ${element.slot.account ? element.slot.account : ''}
                                    ${element.slot.server_address ? '(' + element.slot.server_address + ')' : ''}`,
        product: element.slot.product ? element.slot.product.name : '',
        userInfo: `${element.user.first_name} ${element.user.last_name} (${element.user.username})`,
        date_started: element.date_started,
      };
      filteredConnections.value.push(item);
    }
  });
}

function filterConnection(connection: Connection): boolean {
  switch (tab.value) {
    case 0:
      break;
    case 1:
      if (connection.user.username != store.currentUserName) return false;
  }
  return true;
}

async function loadConnections() {
  loading.value = true;
  allConnections.value = [];
  try {
    let next: string | null = '/api/connections/';
    while (next != null && next != '') {
      console.log('Fetching:', next);
      const items = (await axios.get(next)).data as PagedList<Connection>;
      console.log('Items received:', items.results.length);
      items.results.forEach((element) => {
        allConnections.value.push(element as Connection);
      });
      next = items.next;
    }
    compileTableConnections();
  } catch (e) {
    console.error('Error loading connections:', e);
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadConnections();
});

const connectionPage = ref(1);
const connectionPageSize = ref(50);
const connectionSort = ref<{ key: keyof FilteredConnection; descending: boolean }>({
  key: 'date_started',
  descending: true,
});
const connectionColumns: { key: keyof FilteredConnection; label: string; numeric?: boolean }[] = [
  { key: 'property', label: 'Объект' },
  { key: 'slotInfo', label: 'Слот' },
  { key: 'product', label: 'Продукт' },
  { key: 'userInfo', label: 'Пользователь' },
  { key: 'date_started', label: 'Дата подключения', numeric: true },
];
const searchedConnections = computed(() => {
  const q = search.value.trim().toLowerCase();
  return filteredConnections.value
    .filter(
      (item) => !q || Object.values(item).some((value) => String(value).toLowerCase().includes(q))
    )
    .sort((a, b) => {
      const order = String(a[connectionSort.value.key] ?? '').localeCompare(
        String(b[connectionSort.value.key] ?? ''),
        'ru',
        { numeric: true }
      );
      return connectionSort.value.descending ? -order : order;
    });
});
const connectionPageCount = computed(() =>
  connectionPageSize.value === -1
    ? 1
    : Math.max(1, Math.ceil(searchedConnections.value.length / connectionPageSize.value))
);
const pagedConnections = computed(() =>
  connectionPageSize.value === -1
    ? searchedConnections.value
    : searchedConnections.value.slice(
        (connectionPage.value - 1) * connectionPageSize.value,
        connectionPage.value * connectionPageSize.value
      )
);
function setConnectionSort(key: keyof FilteredConnection) {
  connectionSort.value = {
    key,
    descending: connectionSort.value.key === key ? !connectionSort.value.descending : false,
  };
}
watch([search, tab, connectionPageSize], () => {
  connectionPage.value = 1;
});
watch(connectionPageCount, (count) => {
  connectionPage.value = Math.min(connectionPage.value, count);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("header", { class: "page-heading" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-eyebrow" }, "Доступ к серверам"),
        _createElementVNode("h1", null, "Активные соединения")
      ])
    ], -1)),
    _createVNode(_unref(Card), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Button), {
              size: "sm",
              variant: tab.value === 0 ? 'secondary' : 'ghost',
              "aria-pressed": tab.value === 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 0))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Все подключения ", -1)
              ]))]),
              _: 1
            }, 8, ["variant", "aria-pressed"]),
            _createVNode(_unref(Button), {
              size: "sm",
              variant: tab.value === 1 ? 'secondary' : 'ghost',
              "aria-pressed": tab.value === 1,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 1))
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Мои подключения ", -1)
              ]))]),
              _: 1
            }, 8, ["variant", "aria-pressed"])
          ]),
          _createElementVNode("label", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Поиск", -1)),
            _createVNode(_unref(Input), {
              modelValue: search.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search).value = $event)),
              type: "search",
              placeholder: "Поиск"
            }, null, 8, ["modelValue"])
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_unref(Spinner)),
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "Загрузка подключений…", -1))
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(connectionColumns, (column) => {
                        return _createElementVNode("th", {
                          key: column.key,
                          class: _normalizeClass({ num: column.numeric })
                        }, [
                          _createVNode(_unref(Button), {
                            variant: "ghost",
                            size: "sm",
                            class: "table-sort",
                            onClick: ($event: any) => (setConnectionSort(column.key))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(column.label) + " ", 1),
                              _createVNode(_unref(ArrowDownUp), { size: 13 })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ], 2)
                      }), 64)),
                      _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                        _createElementVNode("span", { class: "sr-only" }, "Действия")
                      ], -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pagedConnections.value, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.slotId
                      }, [
                        _createElementVNode("td", null, [
                          _createVNode(_component_router_link, {
                            to: { name: 'property-detail', params: { id: item.propertyId } },
                            class: "ui-link font-medium"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.property), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.slotInfo), 1),
                        _createElementVNode("td", null, _toDisplayString(item.product || '—'), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(item.userInfo.charAt(0)), 1),
                            _createTextVNode(" " + _toDisplayString(item.userInfo), 1)
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(formatDateTime(item.date_started)), 1),
                        _createElementVNode("td", null, [
                          (isCanBeReleased(item))
                            ? (_openBlock(), _createBlock(_unref(Button), {
                                key: 0,
                                size: "sm",
                                variant: "ghost",
                                class: "text-destructive",
                                disabled: releaseLoad.value,
                                onClick: ($event: any) => (release(item.slotId))
                              }, {
                                default: _withCtx(() => [
                                  (releaseLoad.value)
                                    ? (_openBlock(), _createBlock(_unref(Spinner), { key: 0 }))
                                    : _createCommentVNode("", true),
                                  _cache[11] || (_cache[11] = _createTextVNode(" Освободить ", -1))
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    (!searchedConnections.value.length)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("td", {
                            colspan: "6",
                            class: "text-center text-muted-foreground py-8"
                          }, " Нет подключений по выбранным фильтрам ", -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _cache[13] || (_cache[13] = _createTextVNode(" Строк ", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((connectionPageSize).value = $event)),
                    class: "ui-select",
                    "aria-label": "Строк на странице"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([25, 50, 75, 100, -1], (size) => {
                      return _createElementVNode("option", {
                        key: size,
                        value: size
                      }, _toDisplayString(size === -1 ? 'Все' : size), 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [
                      _vModelSelect,
                      connectionPageSize.value,
                      void 0,
                      { number: true }
                    ]
                  ])
                ]),
                _createElementVNode("span", null, _toDisplayString(searchedConnections.value.length) + " подключений", 1),
                _createVNode(_unref(Button), {
                  variant: "outline",
                  size: "icon",
                  "aria-label": "Предыдущая страница",
                  disabled: connectionPage.value === 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (connectionPage.value--))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronLeft), { size: 16 })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("span", null, _toDisplayString(connectionPage.value) + " / " + _toDisplayString(connectionPageCount.value), 1),
                _createVNode(_unref(Button), {
                  variant: "outline",
                  size: "icon",
                  "aria-label": "Следующая страница",
                  disabled: connectionPage.value >= connectionPageCount.value,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (connectionPage.value++))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ChevronRight), { size: 16 })
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 64))
      ]),
      _: 1
    })
  ]))
}
}

})